export interface BasketItemAddedDetail {
  /** The basket item id */
  id: string;
  /** The quantity added (delta, not total) */
  quantity: number;
  /** The online model code. Only present for old (non-CoCo) basket items. */
  guid?: string;
}

export const BASKET_ITEM_ADDED_EVENT = 'basket-item-added';

export const dispatchBasketItemAdded = (detail: BasketItemAddedDetail): void => {
  window.dispatchEvent(new CustomEvent(BASKET_ITEM_ADDED_EVENT, { detail }));
};
